module.exports = "/static/assets/6761e4cfe7ec1e634d85eb1bb88e8955.png";